var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-tabs", {
    attrs: {
      activeKey: _vm.activeKey
    }
  }, [_c("a-tab-pane", {
    key: 1,
    attrs: {
      tab: _vm.$t("基础信息")
    }
  }, [_c("audit-basics", {
    key: _vm.timer1,
    attrs: {
      id: _vm.id
    },
    on: {
      ok: _vm.handleOk
    }
  })], 1), _c("a-tab-pane", {
    key: 2,
    attrs: {
      tab: _vm.$t("节点流程设置")
    }
  }, [_c("flow-node", {
    key: _vm.timer2,
    attrs: {
      id: _vm.id
    },
    on: {
      Back: _vm.backFun,
      next: _vm.handleOk
    }
  })], 1), _c("a-tab-pane", {
    key: 3,
    attrs: {
      tab: _vm.$t("节点权限")
    }
  }, [_c("white-list", {
    key: _vm.timer3,
    attrs: {
      id: _vm.id
    },
    on: {
      Back: _vm.backFun
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };